"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const carabiners_1 = require("@clearsummit/carabiners");
const react_1 = __importDefault(require("react"));
const constants_1 = require("@/constants");
const styled_react_1 = __importDefault(require("./styled-react"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const SubscriptionRadio = ({ labelString, description, value, onChange, className, readonly, id }) => (react_1.default.createElement("div", { className: styles_scss_1.default.container },
    react_1.default.createElement("div", { className: (0, carabiners_1.joinStr)(styles_scss_1.default.radio, className) },
        react_1.default.createElement("input", { type: "radio", checked: value, onChange: readonly ? () => { } : onChange, id: id }),
        react_1.default.createElement("label", { 
            // eslint-disable-next-line react/no-unknown-property
            css: styled_react_1.default.checkIcon(constants_1.Images.checkRadio), className: styles_scss_1.default.radioLabel, htmlFor: id }, value),
        react_1.default.createElement("div", { className: styles_scss_1.default.iconContainer },
            react_1.default.createElement("img", { src: constants_1.Images.checkRadio, alt: "" }))),
    react_1.default.createElement("div", { className: styles_scss_1.default.textsContainer },
        react_1.default.createElement("h4", { className: styles_scss_1.default.label }, labelString),
        react_1.default.createElement("p", { className: styles_scss_1.default.description }, description))));
SubscriptionRadio.defaultProps = {
    className: undefined
};
exports.default = SubscriptionRadio;
